import { createContext, useContext } from "react";

import { ModalState } from "../types";

interface ModalContextInterface {
  modalState: ModalState;
  setModalState: (
    value: ModalState | ((prev: ModalState) => ModalState),
  ) => void;
  resetModalState: (modalTitle: string) => void;
}

const emptyModalState: ModalState = {
  shouldOpen: false,
  title: "",
  steps: [],
  singleStep: undefined,
  currentStep: 1,
};

const defaultModalState = {
  modalState: emptyModalState,
  setModalState: (): ModalState => emptyModalState,
  resetModalState: (): void => {},
};

const ModalContext = createContext<ModalContextInterface>(defaultModalState);

export const useModalContext = (): ModalContextInterface =>
  useContext(ModalContext);

export default ModalContext;
